function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { v4 as uuidv4 } from 'uuid';
export default {
  data() {
    return {
      jobEventHistory: [],
      mapJobActions: {
        'job:create': 'create_group',
        'job:move': 'move_group',
        'job:move_down': 'move_down',
        'job:move_up': 'move_up',
        'job:remove': 'remove'
      }
    };
  },
  computed: {
    availableJobActions() {
      return [{
        title: 'Groep maken',
        action: 'create_group',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-8-4h2v2h2v-2h2v-2h-2v-2h-2v2h-2z"/></svg>',
        visible: true,
        callback: (action = null, initSelection = null) => {
          const actionId = uuidv4();
          const jobs = [];
          const newGroups = _.cloneDeep(this.groups);
          const selection = initSelection ? initSelection : this.getSelection('job');
          selection.forEach(jobId => {
            const group = this.findGroupByJob(jobId, newGroups);
            group.jobs = group.jobs.filter(job => {
              if (job.id === jobId) {
                jobs.push(job);
              }
              return job.id !== jobId;
            });
          });
          let lastGroup = this.groups[this.groups.length - 1];
          if (lastGroup.group.id < 0) {
            lastGroup = this.groups[this.groups.length - 2];
          }
          const newGroupNumber = this.groups.length;
          const newGroup = {
            driver: null,
            group: action.group ? action.group : {
              closed: 0,
              id: -1,
              uuid: uuidv4(),
              name: 'Groep ' + newGroupNumber,
              order: lastGroup ? lastGroup.group.order - 1 : 1000,
              slug: null,
              finalized_at: null,
              finalized_by: null,
              main_group_id: 5
            },
            jobs: jobs
          };
          newGroups.unshift(newGroup);
          const newGroupsStart = [];
          const newGroupsMiddle = [];
          const newGroupsEnd = [];
          if (newGroups[newGroups.length - 1].group.uuid === 'plan') {
            newGroupsEnd.push(newGroups.pop());
          }
          newGroups.map(group => {
            if (newGroup.group.uuid === group.group.uuid) {
              newGroupsMiddle.push(group);
            } else {
              newGroupsStart.push(group);
            }
          });
          this.groups = [].concat(newGroupsStart, newGroupsMiddle, newGroupsEnd).map(function (group, index) {
            group.group.order = 1000 - index;
            return group;
          });
          if (!initSelection) {
            this.whisperJob('job:create', {
              group: newGroup.group,
              selection: selection,
              actionId: actionId,
              main_group_id: 0
            });
            this.saving = true;
            this.$http.post('/plannen/create-group?date= ' + moment(this.date).format('YYYY-MM-DD') + '&actionId=' + actionId, {
              id: newGroup.group.uuid,
              name: newGroup.group.name,
              jobs: newGroup.jobs.map(job => job.id),
              order: newGroup.group.order,
              main_group_id: 0
            }).then(response => {
              this.saving = false;
            });
            setTimeout(() => {
              this.scrollToGroup(newGroup.group.uuid);
            }, 100);
          }
          setTimeout(() => {
            this.setSortable();
          }, 1000);
          return true;
        }
      }, {
        title: 'Toewijzen aan groep',
        action: 'move_group',
        items: this.groupListFiltered,
        icon: '<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"/></g><g><path d="M20,6h-8l-2-2H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8C22,6.9,21.1,6,20,6z M20,18H4V6h5.17l1.41,1.41 L11.17,8H20V18z M12.16,12H8v2h4.16l-1.59,1.59L11.99,17L16,13.01L11.99,9l-1.41,1.41L12.16,12z"/></g></svg>',
        visible: true,
        callback: (action = null, initSelection = null) => {
          const actionId = uuidv4();
          const jobs = [];
          const newGroups = _.cloneDeep(this.groups);
          const selection = initSelection ? initSelection : this.getSelection('job');
          selection.forEach(jobId => {
            const group = this.findGroupByJob(jobId, newGroups);
            group.jobs = group.jobs.filter(job => {
              if (job.id === jobId) {
                job.status_text_with_icon = null;
                jobs.push(job);
              }
              return job.id !== jobId;
            });
          });
          const group = newGroups.find(group => {
            return group.group.uuid === action.subAction.uuid;
          });
          if (!group) {
            return;
          }
          group.jobs = [].concat(_toConsumableArray(group.jobs), jobs);
          if (!initSelection) {
            this.confirmWhenPlanned(() => {
              this.groups = newGroups;
              this.whisperJob('job:move', {
                subAction: action.subAction,
                selection: selection,
                actionId: actionId
              });
              this.saving = true;
              this.$http.post('/plannen/move-jobs?date=' + moment(this.date).format('YYYY-MM-DD') + '&actionId=' + actionId, [{
                id: group.group.uuid,
                jobs: jobs.map(job => job.id),
                order: group.jobs.map(job => job.id)
              }]).then(response => {
                this.saving = false;
              });
            }, () => {}, !!group.driver);
          } else {
            this.groups = newGroups;
          }
          return true;
        }
      }, {
        title: 'Omlaag verplaatsen',
        action: 'move_down',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><rect fill="none" height="24" width="24"/><path d="M19,15l-1.41-1.41L13,18.17V2H11v16.17l-4.59-4.59L5,15l7,7L19,15z"/></svg>',
        visible: true,
        callback: (action = null, initSelection = null) => {
          const actionId = uuidv4();
          const selection = initSelection ? initSelection : this.getSelection('job');
          const newGroups = _.cloneDeep(this.groups);
          const data = [];
          newGroups.forEach(group => {
            const newJobs = _toConsumableArray(group.jobs);
            for (let i = newJobs.length - 1; i >= 0; i--) {
              const job = newJobs[i];
              const nextJob = newJobs[i + 1];
              const shouldMoveCurrentJob = selection.includes(job.id);
              const canMoveJob = i < newJobs.length - 1 && nextJob && !selection.includes(nextJob.id);
              if (shouldMoveCurrentJob && canMoveJob) {
                newJobs.splice(i, 2, nextJob, job);
              }
            }
            group.jobs = newJobs.map(function (job, index) {
              job.order = index;
              return job;
            });
            if (group.jobs.some(job => selection.includes(job.id))) {
              data.push({
                id: group.group.uuid,
                jobs: group.jobs.filter(job => selection.includes(job.id)).map(job => job.id),
                order: group.jobs.map(job => job.id),
                date: this.date
              });
            }
          });
          this.groups = newGroups;
          if (!initSelection) {
            this.whisperJob('job:move_down', {
              selection: selection,
              actionId: actionId
            });
            this.saving = true;
            this.$http.post('/plannen/move-jobs?date=' + moment(this.date).format('YYYY-MM-DD') + '&actionId=' + actionId, data).then(response => {
              this.updateGroup(data[0].id);
              this.saving = false;
            });
          }
          return false;
        }
      }, {
        title: 'Omhoog verplaatsen',
        action: 'move_up',
        icon: '<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><rect fill="none" height="24" width="24"/><path d="M5,9l1.41,1.41L11,5.83V22H13V5.83l4.59,4.59L19,9l-7-7L5,9z"/></svg>',
        visible: true,
        callback: (action = null, initSelection = null) => {
          const actionId = uuidv4();
          const selection = initSelection ? initSelection : this.getSelection('job');
          const newGroups = _.cloneDeep(this.groups);
          const data = [];
          newGroups.forEach(group => {
            const newJobs = _toConsumableArray(group.jobs);
            for (let i = 0; i < newJobs.length; i++) {
              const job = newJobs[i];
              const previousJob = newJobs[i - 1];
              const shouldMoveCurrentJob = selection.includes(job.id);
              const canMoveJob = i > 0 && previousJob && !selection.includes(previousJob.id);
              if (shouldMoveCurrentJob && canMoveJob) {
                newJobs.splice(i - 1, 2, job, previousJob);
              }
            }
            group.jobs = newJobs.map(function (job, index) {
              job.order = index;
              return job;
            });
            if (group.jobs.some(job => selection.includes(job.id))) {
              data.push({
                id: group.group.uuid,
                jobs: group.jobs.filter(job => selection.includes(job.id)).map(job => job.id),
                order: group.jobs.map(job => job.id),
                date: this.date
              });
            }
          });
          this.groups = newGroups;
          if (!initSelection) {
            this.whisperJob('job:move_up', {
              selection: selection,
              actionId: actionId
            });
            this.saving = true;
            this.$http.post('/plannen/move-jobs?date=' + moment(this.date).format('YYYY-MM-DD') + '&actionId=' + actionId, data).then(response => {
              this.updateGroup(data[0].id);
              this.saving = false;
            });
          }
          return false;
        }
      }, {
        title: 'Verwijderen',
        action: 'remove',
        type: 'danger',
        confirmable: true,
        icon: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"/></svg>',
        visible: true,
        callback: (action = null, initSelection = null) => {
          const actionId = uuidv4();
          const jobs = [];
          const data = [];
          const newGroups = _.cloneDeep(this.groups);
          const selection = initSelection ? initSelection : this.getSelection('job');
          selection.forEach(jobId => {
            const group = this.findGroupByJob(jobId, newGroups);
            if (group) {
              group.jobs = group.jobs.filter(job => {
                if (job.id === jobId) {
                  data.push({
                    id: jobId
                  });
                  jobs.push(job);
                }
                return job.id !== jobId;
              });
            }
          });
          const group = newGroups.find(group => {
            return group.group.uuid === 'plan';
          });
          group.jobs = [].concat(_toConsumableArray(group.jobs), jobs).filter((v, i, a) => a.findIndex(v2 => v2.id === v.id) === i);
          ;
          this.groups = newGroups;
          if (!initSelection) {
            this.whisperJob('job:remove', {
              selection: selection,
              actionId: actionId
            });
            this.saving = true;
            this.$http.post('/plannen/delete-jobs?date=' + moment(this.date).format('YYYY-MM-DD') + '&actionId=' + actionId, data).then(response => {
              this.saving = false;
            });
          } else {
            this.selectedJobs = this.selectedJobs.filter(job => !selection.includes(job));
          }
          return true;
        }
      }];
    },
    jobActions() {
      const selectedJobs = this.contextMenuSelection ? [this.contextMenuSelection.data.id] : this.selectedJobs;
      const groups = _.cloneDeep(this.groups);
      const selectionHasGroup = groups.some(group => {
        return group.group.uuid !== 'plan' && group.jobs.some(job => selectedJobs.includes(job.id));
      });
      return this.availableJobActions.map(action => {
        action.visible = !(!selectionHasGroup && ['remove', 'move_up', 'move_down'].includes(action.action));
        if (!this.hasGroups && action.action === 'move_group') {
          action.visible = false;
        }
        return action;
      });
    }
  },
  methods: {
    jobAction(action, actionData, data) {
      const jobAction = this.availableJobActions.find(jobAction => {
        return jobAction.action === action;
      });
      jobAction.callback(actionData, data);
    },
    whisperJob(action, event) {
      this.jobEventHistory.push(event.actionId);
      this.echoChannel.whisper(action, event);
    },
    catchWhisperJob(action, event) {
      this.jobEventHistory.push(event.actionId);
      this.jobAction(this.mapJobActions[action], event, event.selection);
    },
    backupJobWhisperAction(action, event) {
      const jobEventAlreadyFired = this.jobEventHistory.includes(event.actionId);
      if (!jobEventAlreadyFired) {
        this.catchWhisperJob(action, event);
      }
    }
  }
};


// WEBPACK FOOTER //
// ./resources/js/components/plan/mixins/JobActionsMixin.js